import ActionType from "./action-type";
import { fromJS } from "immutable";
import {
  createActionTypeOnStart,
  createActionTypeOnSuccess,
  createActionTypeOnFailure,
} from "../unfoldSaga";

const initialState = fromJS({
  type: null,
  loading: false,
  payload: null,
  error: null,
  businessImages: [],
  metadata: { total: 0, page: 1, limit: 20 },
  cache: {},
});

const toMediaReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case createActionTypeOnStart(ActionType.FETCH_IMAGE):
      return state
        .set("type", fromJS(action.type))
        .set("loading", fromJS(true))
        .set("payload", null)
        .set("error", null);
    case createActionTypeOnSuccess(ActionType.FETCH_IMAGE):
      return state
        .set("type", fromJS(action.type))
        .set("loading", fromJS(false))
        .set("payload", fromJS(action.payload.result))
        .set("error", null);
    case createActionTypeOnFailure(ActionType.FETCH_IMAGE):
      return state
        .set("type", fromJS(action.type))
        .set("loading", fromJS(false))
        .set("payload", null)
        .set("error", fromJS(action.error));
    case createActionTypeOnStart(ActionType.FETCH_BUSINESS_IMAGES):
      return state
        .set("loading", fromJS(true));
    case createActionTypeOnSuccess(ActionType.FETCH_BUSINESS_IMAGES):
      const { businessId, params } = action.payload;
      const cacheKey = `${businessId}-${params.page}-${params.search || ''}`;
      return state
        .set("loading", fromJS(false))
        .set("businessImages", fromJS(action.payload.result))
        .set("metadata", fromJS(action.payload.meta))
        .setIn(["cache", cacheKey], fromJS(action.payload));
    case createActionTypeOnFailure(ActionType.FETCH_BUSINESS_IMAGES):
      return state
        .set("loading", fromJS(false))
        .set("error", fromJS(action.error));
    case ActionType.SET_MEDIA_DATA:
      return state
        .set("businessImages", fromJS(action.data.result))
        .set("metadata", fromJS(action.data.meta));
    case createActionTypeOnSuccess(ActionType.UPLOAD_PUBLIC_IMAGE):
    case createActionTypeOnSuccess(ActionType.DELETE_MULTIPLE_FILES):
      return state.set("cache", fromJS({})); // Xóa cache khi dữ liệu thay đổi
    default:
      return state;
  }
};
export default toMediaReducer;
